import { communication } from '../../api/communication';
import { BrowserFourdApi } from '.';

export class Communication implements communication.Api {
  constructor(private fourd: BrowserFourdApi) {}

  composeEmail(request: communication.CreateEmailRequest): void {
    this.fourd.call4Dv2('communication.composeEmail', request);
  }

  createAppointment(request: communication.CreateAppointmentRequest): void {
    this.fourd.call4Dv2('communication.createAppointment', request);
  }

  createTask(request: communication.CreateTaskRequest): void {
    this.fourd.call4Dv2('communication.createTask', request);
  }
}
